import cardCreate from 'assets/images/homepage/callout_cards/card-create.webp'
import cardDiscussion from 'assets/images/homepage/callout_cards/card-discussion.webp'
import cardPolls from 'assets/images/homepage/callout_cards/card-polls.webp'
import cardReactions from 'assets/images/homepage/callout_cards/card-reactions.webp'
import cardReaderReactions from 'assets/images/homepage/callout_cards/card-reader-reactions.webp'
import cardPrompts from 'assets/images/homepage/callout_cards/card-prompts.webp'
import cardTabs from 'assets/images/homepage/callout_cards/card-tabs.webp'
import cardHighlights from 'assets/images/homepage/callout_cards/card-highlights.webp'
import { GridCalloutCard } from 'components/grid_callout/types'

export const clubCards: GridCalloutCard[] = [
  {
    text: 'Join (or start!) a free book club',
    image: cardCreate,
    altText: 'book clubs preview',
  },
  {
    text: 'Discuss in spoiler-free chat rooms',
    image: cardDiscussion,
    altText: 'club milestones preview',
  },
  {
    text: 'Organize with tools built for clubs',
    image: cardPolls,
    altText: 'club polls preview',
  },
  {
    text: 'Buy the ebook for additional features',
    image: cardReactions,
    altText: 'reader reactions preview',
  },
]

export const bookCards: GridCalloutCard[] = [
  {
    text: 'Share emoji reactions as you read in real-time',
    image: cardReaderReactions,
    altText: 'reader reactions preview',
  },
  {
    text: 'Spark discussion right inside the book',
    image: cardPrompts,
    altText: 'prompts preview',
  },
  {
    text: 'Use tabs to mark and organize key moments',
    image: cardTabs,
    altText: 'tabs preview',
  },
  {
    text: 'Create highlights and private notes',
    image: cardHighlights,
    altText: 'highlights preview',
  },
]
